import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store";

const ArcGoogleMapReducer = (state: RootState) => state.MapReducer;
const ArcGoogleMapState = createSelector([ArcGoogleMapReducer], (state) => state);

export const selectMapZoom = createSelector([ArcGoogleMapState], (map) => map.zoom);
export const selectMapType = createSelector([ArcGoogleMapState], (map) => map.type);
export const selectMapCenter = createSelector([ArcGoogleMapState], (map) => map.center);
export const selectMapLocation = createSelector([ArcGoogleMapState], (map) => map.location);
export const selectWeatherExpanded = createSelector([ArcGoogleMapState], (map) => map.weatherExpanded ?? false);